import React, { useEffect, useState } from 'react';
import { Typography, Box } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import { isURL } from '../utils/utility';
import appLogo from '../assets/appLogo.webp';
import { useTheme } from '@emotion/react';
import { useLocation } from 'react-router-dom';







function PackageCard({  name, onClick, categoryName, downloadUrl, info }) {

  const overlayText = info?.summary;
  const logoName = info?.logo;

  const theme = useTheme();
  const location = useLocation();


  const packageWrapperStyles = {
    // width: "210px",
    overflow: "hidden",
    boxShadow: "none",
    cursor: "pointer",
    borderRadius: "16px",
    // margin: "20px 10px",
    background: "#fafafa",
    padding: "20px",
    '&:hover': {
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      background: "#fff",
    },
    [theme.breakpoints.down("sm")]: {
      padding: '10px'
    },
  }


  const imageContainerStyles = {
    position: 'relative',
    borderRadius: '25px',
    margin: 'auto',
    overflow: 'hidden',
    // width: '100%',
    width: 'auto',
    height: '185px',
    boxShadow: 'none',
    display: 'flex',
    alignItems: 'center'
    // [theme.breakpoints.down("sm")]: {
    //  height:'auto'
    // },
  }




  const imageUrl = logoName && isURL(logoName) ? logoName : downloadUrl && logoName ? `${downloadUrl}/${logoName}` : '';
  const overlayTextUpdated = overlayText || "This is a sample text. Description does not exist for this component";



  return (
    <Box onClick={onClick} sx={packageWrapperStyles}>
      {/* <div style={{height:'185px', display:'flex'}}> */}
      <Box
        sx={imageContainerStyles}
      >
        {imageUrl ? (
          <img
            src={imageUrl}
            alt="package"
            style={{ width: '100%', height: 'auto' }}
          />
        ) : (
          <img
            src={appLogo}
            alt="package"
            style={{ width: '100%', height: 'auto' }}
          />
        )}
      </Box>
      {/* </div> */}
      <Box sx={{display:'flex', justifyContent:'space-between'}}>
              <Typography
        variant="body2"
        sx={{
          padding: "5px 10px",
          borderRadius: "25px",
          background: "#EBEBEB",
          margin: "10px 0",
          display: "inline-block",
          fontWeight: '500'
        }}
      >
        {categoryName ? categoryName : "Others"}
      </Typography>

              {
        location.pathname === '/pending-review' && process.env.REACT_APP_STAGE === 'development' ? <Typography variant="body2"
 sx={{
  padding: "5px 10px",
  borderRadius: "25px",
  background: "#ffffff",
  margin: "10px 0",
  display: "inline-block",
  fontWeight: 500,
  color: (theme) => theme.palette.primary.main,
  border: (theme) => `1px solid ${theme.palette.primary.main}`,
}}
> 
          v{info?.underReview}
        </Typography>  : null
      }

      </Box>


      <Typography sx={{ marginBottom: '10px', fontWeight: '600', fontSize: '16px' }}  >{name}</Typography>
      <Typography sx={{ marginBottom: '10px', color: theme => theme.palette.primary.textColor }} variant='body2'>{overlayTextUpdated && overlayTextUpdated.length > 70 ? overlayTextUpdated.substring(0, 70) + '...' : overlayTextUpdated}</Typography>


    </Box>
  );
}

export default PackageCard;
